/* unplugin-vue-components disabled */import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue";
import _imports_0 from '@/assets/images/fullscreen.png';
const _hoisted_1 = {
  class: "container_box"
};
const _hoisted_2 = {
  key: 0,
  class: "controls"
};
const _hoisted_3 = {
  key: 0,
  class: "control-left"
};
const _hoisted_4 = {
  key: 1,
  class: "control-left"
};
const _hoisted_5 = {
  key: 1,
  class: "controls-small"
};
const _hoisted_6 = {
  key: 0,
  class: "control-left"
};
const _hoisted_7 = {
  key: 1,
  class: "control-left"
};
export default {
  __name: 'index',
  props: {
    /**
     * 是否显示开关
     */
    showSwitch: {
      type: Boolean,
      default: true
    },
    showFullScreen: {
      type: Boolean,
      default: true
    },
    showExchange: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示录制视频
     */
    showVideoCamera: {
      type: Boolean,
      default: true
    },
    /**
     * 是否为视频播放div
     */
    videoDivIs: {
      type: Boolean,
      default: true
    },
    /**
     * 设备类型
     * @type Enum
     * @options ["default","small"]
     */
    deviceType: {
      type: String,
      default: 'default'
    },
    /**
     * 是否显示截图
     */
    showPictureOutlined: {
      type: Boolean,
      default: true
    },
    /**
     * 是否显示字幕
     */
    showSubtitle: {
      type: Boolean,
      default: true
    },
    /**
     * 控制尺寸
     * @type Enum
     * @options ["default","small"]
     */
    controlelSize: {
      type: String,
      default: 'default'
    },
    /**
     * 保持宽高
     */
    showAspectRatio: {
      type: Boolean,
      default: false
    },
    /**
     * 保持宽高比
     */
    aspectRatioState: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const cChecked = ref(true);
    const cChecked1 = ref(true);
    const timer = ref(null);
    watch(() => props.showSubtitle, (newVal, oldVal) => {
      cChecked.value = props.showSubtitle;
    }, {
      deep: true
    });
    function updateView() {
      emit("updateView");
    }
    function switchChange(e) {
      emit('switchChange', e);
    }
    function switchChangezhishengji(e) {
      emit('switchChangezhishengji', e);
    }
    function fullScreenClick() {
      emit('fullScreenClick');
    }
    function exchangeClick() {
      emit('exchangeClick');
    }
    function videoClick() {
      emit('videoClick');
    }
    function screenCutClick() {
      emit('screenCutClick');
    }
    function reduction() {
      emit('reduction');
    }
    onMounted(() => {
      cChecked.value = props.showSubtitle;
      if (!props.showAspectRatio) {
        timer.value = setInterval(e => {
          updateView();
        }, 10);
      } else {
        clearInterval(timer.value);
      }
    });
    onBeforeUnmount(() => {
      clearInterval(timer.value);
    });
    return (_ctx, _cache) => {
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_ChromeOutlined = _resolveComponent("ChromeOutlined");
      const _component_VideoCameraAddOutlined = _resolveComponent("VideoCameraAddOutlined");
      const _component_PictureOutlined = _resolveComponent("PictureOutlined");
      const _component_FullscreenExitOutlined = _resolveComponent("FullscreenExitOutlined");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.controlelSize == 'default' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [__props.showSwitch && __props.deviceType === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[4] || (_cache[4] = _createTextVNode(" 字幕", -1)), _createVNode(_component_a_switch, {
        onChange: switchChange,
        checked: _unref(cChecked),
        "onUpdate:checked": _cache[0] || (_cache[0] = $event => _isRef(cChecked) ? cChecked.value = $event : null),
        style: {
          "width": "2rem"
        }
      }, null, 8, ["checked"])])) : _createCommentVNode("", true), !__props.showSwitch && !__props.videoDivIs ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[5] || (_cache[5] = _createTextVNode(" 字幕", -1)), _createVNode(_component_a_switch, {
        onChange: switchChangezhishengji,
        checked: _unref(cChecked1),
        "onUpdate:checked": _cache[1] || (_cache[1] = $event => _isRef(cChecked1) ? cChecked1.value = $event : null),
        size: "small"
      }, null, 8, ["checked"])])) : _createCommentVNode("", true), __props.showExchange ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "control-item",
        onClick: exchangeClick
      }, [_createVNode(_component_ChromeOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true), __props.showFullScreen ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "control-item",
        onClick: fullScreenClick
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1)]))])) : _createCommentVNode("", true), __props.showVideoCamera ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "control-item",
        onClick: videoClick
      }, [_createVNode(_component_VideoCameraAddOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true), __props.showPictureOutlined ? (_openBlock(), _createElementBlock("div", {
        key: 5,
        class: "control-item",
        onClick: screenCutClick
      }, [_createVNode(_component_PictureOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true), __props.showAspectRatio ? (_openBlock(), _createElementBlock("div", {
        key: 6,
        class: "control-item",
        onClick: reduction
      }, [_createVNode(_component_FullscreenExitOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [__props.showSwitch ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[7] || (_cache[7] = _createTextVNode(" 字幕", -1)), _createVNode(_component_a_switch, {
        onChange: switchChange,
        checked: _unref(cChecked),
        "onUpdate:checked": _cache[2] || (_cache[2] = $event => _isRef(cChecked) ? cChecked.value = $event : null),
        size: "small"
      }, null, 8, ["checked"])])) : _createCommentVNode("", true), !__props.showSwitch && !__props.videoDivIs ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[8] || (_cache[8] = _createTextVNode(" 字幕", -1)), _createVNode(_component_a_switch, {
        onChange: switchChangezhishengji,
        checked: _unref(cChecked1),
        "onUpdate:checked": _cache[3] || (_cache[3] = $event => _isRef(cChecked1) ? cChecked1.value = $event : null),
        size: "small"
      }, null, 8, ["checked"])])) : _createCommentVNode("", true), __props.showExchange ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "control-item",
        onClick: exchangeClick
      }, [_createVNode(_component_ChromeOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true), __props.showFullScreen ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "control-item",
        onClick: fullScreenClick
      }, [...(_cache[9] || (_cache[9] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1)]))])) : _createCommentVNode("", true), __props.showVideoCamera ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "control-item",
        onClick: videoClick
      }, [_createVNode(_component_VideoCameraAddOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true), __props.showPictureOutlined ? (_openBlock(), _createElementBlock("div", {
        key: 5,
        class: "control-item",
        onClick: screenCutClick
      }, [_createVNode(_component_PictureOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true), __props.showAspectRatio ? (_openBlock(), _createElementBlock("div", {
        key: 6,
        class: "control-item",
        onClick: reduction
      }, [_createVNode(_component_FullscreenExitOutlined, {
        class: "img"
      })])) : _createCommentVNode("", true)])), _renderSlot(_ctx.$slots, "default")]);
    };
  }
};